import React from 'react';
import SecretaryForm from '../../../components/forms/SecretaryForm';

export default function SecretariesCreatePage() {
  return <SecretaryForm />;
}
